import {Box, Typography, Tooltip} from "@material-ui/core"
import InvoyageTooltip from "./InvoyageTooltip"
const COLOR_MAP = {
  PROCESSED_AUTO: "#1ab394",
  PROCESSED_MANUAL: "#1ab394",
  PROCESSED_FORCE: "#d88428",
  PROCESSED_FORCE_AUTO: "#d88428",
  ERROR: "red"
}
const CLIENT_USER_COLOR_MAP = {
  ERROR: "#FFA500" // "orange" as a warning color
}

const TEXT_MAP = {
  PROCESSED_AUTO: "Auto Imported",
  PROCESSED_MANUAL: "Manually Imported",
  PROCESSED_FORCE: "Skipped",
  PROCESSED_FORCE_AUTO: "Skipped 🤖",
  ERROR: "Error"
}

const CLIENT_USER_TEXT_MAP =  {
  PROCESSED_AUTO: "Auto Imported",
  PROCESSED_MANUAL: "Manually Imported",
  PROCESSED_FORCE: "Skipped",
  PROCESSED_FORCE_AUTO: "Skipped 🤖",
  ERROR: "Warn",
  UNPROCESSED: "Uploaded",
  METADATA_APPLIED: "Extracted",
  GPT_PARSED: "Parsed" 
}

export default ({table, status, title, user}) => {

  return (
    <InvoyageTooltip open={status == "ERROR" ? undefined : false} title={title}>

      <div style={{display: 'flex', justifyContent: 'center'}}>
        <Box 
          sx={{
            margin: table ? 0 : "0 5px",
            backgroundColor: (user && user.admin && CLIENT_USER_COLOR_MAP[status]) || COLOR_MAP[status] || '#999',
            borderRadius: 15, // rounded corners
            border: "2px solid gray",
            padding: "2px 8px",
            width: 'fit-content',
            textAlign: 'center'
          }}
          >
          <Typography variant="body1" color="white" style={{fontWeight: 'bold'}}>
            {(user && user.admin ? TEXT_MAP[status] : CLIENT_USER_TEXT_MAP[status]) || "Unprocessed"}
          </Typography>
        </Box>
      </div>
    </InvoyageTooltip>
  );
}